export const CFG = {
  /* star density: px² per star */
  densityFar: 14000,
  countMin: 40,
  countMax: 140,

  /* connections */
  connectDistance: 160,
  connectDistanceCompact: 120,
  lineAlpha: 0.32,
  baseLineWidth: 0.6,

  /* cursor */
  cursorLineAlpha: 0.35,
  cursorLineWidth: 0.8,
  cursorNearest: 3,

  /* twinkle */
  twinkleSpeedMin: 0.3,
  twinkleSpeedMax: 1.0,

  /* breakpoint */
  breakpoint: 760,
};
